import React from 'react'
import classNames from 'classnames'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'

/**
 * v7 `.platform-card` — coloured glyph, title, secondary line and a chevron.
 * Renders as a Link when a route is given, otherwise as a flat card.
 */
const PlatformShortcutCard = ({ glyph, tone, title, meta, to }) => {
  const body = (
    <>
      <span
        className={`experience-home-platform-icon platform-icon-${tone}`}
        aria-hidden='true'>
        {glyph}
      </span>
      <span>
        <b>{title}</b>
        {meta != null ? <small>{meta}</small> : null}
      </span>
      {to ? <i aria-hidden='true'>→</i> : null}
    </>
  )

  if (!to) {
    return (
      <div
        className={classNames('experience-home-platform-card', 'is-disabled')}
        aria-disabled='true'>
        {body}
      </div>
    )
  }

  return (
    <Link className='experience-home-platform-card' to={to}>
      {body}
    </Link>
  )
}

PlatformShortcutCard.propTypes = {
  glyph: PropTypes.node,
  tone: PropTypes.string.isRequired,
  title: PropTypes.node.isRequired,
  meta: PropTypes.node,
  to: PropTypes.string,
}

export default PlatformShortcutCard
